import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { BillData, Bill, BillDetail, BillMaster, BillPayment,CommonPayment, BillReceipt } from './../@core/interfaces/masters/bill';
import { BillApi } from '../@core/backend/common/api/bill.api';
@Injectable()
export class BillService extends BillData {

  constructor(private api: BillApi) {
    super();
  }

  // getIpBills(id:string): Observable<any[]> {
  //  return this.http.get<any[]>(environment.baseUrl + 'bill/ip/' + id);
  //}
  //getOpBills(id:string): Observable<any[]> {
  //  return this.http.get<any[]>(environment.baseUrl + 'bill/op/' + id);
  //}
  //getPharmacyBills(id:string): Observable<any[]> {
  //  return this.http.get<any[]>(environment.baseUrl + 'bill/Pharmacy/' + id);
  //}
  //getPatientBill(visitId: number, tenantId: number){
  //  let header = new HttpHeaders();
  //  header.append('Content-Type', 'applications/json');
  //  return this.http.get(environment.baseUrl + 'bill/patientbilldetail/'+ visitId + '/' + tenantId, { headers: header})
  //}

  list(url: string): Observable<BillMaster[]> {
    return this.api.list(url);
  }

  listByParams(url:string, regId:string, woFrom:string, refId:string, dpRegId:string): Observable<BillMaster[]> {
    return this.api.listByParams(url, regId, woFrom, refId, dpRegId);
  }

  getbyid(url: string): Observable<any[]> {
    return this.api.getbyid(url);
  }

  BillServiceRevenuelist(url: string): Observable<any[]> {
    return this.api.BillServiceRevenuelist(url);
  }

  
  getById(url: string): Observable<Bill> {
    return this.api.getById(url);
  }

  update(url: string, data: any): Observable<any> {
    return this.api.update(url, data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  deletehold(url: string, data: any): Observable<any> {
    return this.api.deletehold(url,data);
  }

  create(url: string, data: any[]): Observable<any> {
    return this.api.add(url, data);
  }

  createBillMaster(url: string, data: BillMaster): Observable<BillMaster> {
    return this.api.addBillMaster(url, data);
  }
  createBillPayment(url: string, data: BillPayment): Observable<BillPayment> {
    return this.api.addBillPayment(url, data);
  }
 createCommonPayment(url: string, data: any[]): Observable<any> {
    return this.api.createCommonPayment(url, data);
  }

createBillReceipt(url: string, data: any): Observable<any> {
    return this.api.createBillReceipt(url, data);
  }
  billDtllist(url: string): Observable<BillDetail[]> {
    return this.api.billDtlList(url );
  }
  commonPaymentList(url: string): Observable<any> {
    return this.api.commonPaymentList(url);
  }

 billReceiptList(url: string): Observable<any> {
    return this.api.billReceiptList(url);
  }
  patientPaymentServices(url: string): Observable<any> {
    return this.api.patientPaymentServices(url);
  }

  billPaymentlist(url: string): Observable<BillPayment[]> {
    return this.api.billDtlList(url);
  }

  TenantBranch(url: string): Observable<any[]> {
    return this.api.billDtlList(url);
  }



//**
billTodaylist(url: string): Observable<any[]> {
  return this.api.billlist(url);
} 
billYesterdaylist(url: string): Observable<any[]> {
  return this.api.billlist(url);
} 
billWeeklylist(url: string): Observable<any[]> {
  return this.api.billlist(url);
} 
billMonthlylist(url: string): Observable<any[]> {
  return this.api.billlist(url);
} 
billYearlylist(url: string): Observable<any[]> {
  return this.api.billlist(url);
} 




  billDailylist(url: string): Observable<any[]> {
    return this.api.billlist(url);
  }  
  serviceWiseList(url: string): Observable<any[]> {
    return this.api.serviceList(url);
  }

  serviceTodaylist(url: string): Observable<any[]> {
    return this.api.serviceList(url);
  } 
  serviceYesterdaylist(url: string): Observable<any[]> {
    return this.api.serviceList(url);
  } 
  serviceWeeklylist(url: string): Observable<any[]> {
    return this.api.serviceList(url);
  } 
  serviceMonthlylist(url: string): Observable<any[]> {
    return this.api.serviceList(url);
  } 
  serviceYearlylist(url: string): Observable<any[]> {
    return this.api.serviceList(url);
  } 

//**




  

  updateBillMaster(url: string,data: BillMaster): Observable<BillMaster> {
    return this.api.updateBillMaster(url, data);
  }
updateBillReceipt(url: string, data: BillReceipt): Observable<BillReceipt> {
    return this.api.updateBillReceipt(url, data);
  }
  

  updateBillPayment(url: string, data: BillPayment): Observable<BillMaster> {
    return this.api.updateBillPayment(url, data);
  }

  GetdiagnosisCount(url: string): Observable<any> {
    return this.api.GetdiagnosisCount(url);
  }

  deleteBillDtlTable(url: string): Observable<boolean> {
    return this.api.deleteBillDtlTable(url);
  }
  deleteBillCommonPayment(url: string): Observable<boolean> {
    return this.api.deleteBillCommonPayment(url);
  }

  advancelist(url: string): Observable<any> {
    return this.api.advancelistlist(url);
  }
  get(url:string):Observable<any> {
    return this.api.get(url)
  }

  

  advancecreate(url: string, data: any): Observable<any> {
    return this.api.advanceadd(url,data);
  }

  advanceupdate(url: string, data: any): Observable<any> {
    return this.api.advanceupdate(url,data);
  }

  advancedelete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  advancesearchList(url: string,data:any): Observable<any> {  
    return this.api.advancesearchList(url,data);
  }

  cancelBill(url: string,data): Observable<any> {
    return this.api.cancelBill(url, data);
  }

  // credit bill-insurance:-
  creditbilllist(url: string): Observable<any> {
    return this.api.creditbilllist(url);
  }

  creditbillsearchList(url: string,data:any): Observable<any> {  
    return this.api.creditbillsearchList(url,data);
  }

  createbillOPDSlip(url: string,data:any): Observable<any> {  
    return this.api.createbillOPDSlip(url,data);
}
  
}
